"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertCounter = exports.Counter = exports.transformCounter = exports.DEFAULT_COUNTER_COLOR = exports.DEFAULT_COUNTER_BACKGROUND_COLOR = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const ramda_1 = require("ramda");
const DEFAULT_MAX_COUNT = 99;
exports.DEFAULT_COUNTER_BACKGROUND_COLOR = {
    color: 'danger'
};
exports.DEFAULT_COUNTER_COLOR = {
    color: 'onPrimary'
};
const DEFAULT_SIZE = 'large';
const transformCounter = (counter, max) => {
    if ((0, ramda_1.isNil)(counter) || counter < 0)
        return '...';
    if (counter > max)
        return `${max}+`;
    return counter;
};
exports.transformCounter = transformCounter;
const Counter = (_a) => {
    var { count, counterBackgroundColor = exports.DEFAULT_COUNTER_BACKGROUND_COLOR, maxCount = DEFAULT_MAX_COUNT, size = DEFAULT_SIZE, counterColor = exports.DEFAULT_COUNTER_COLOR } = _a, rest = __rest(_a, ["count", "counterBackgroundColor", "maxCount", "size", "counterColor"]);
    return (react_1.default.createElement(styled_1.StyledCounter, Object.assign({ "$counterBackgroundColor": counterBackgroundColor, "$size": size, "$counterColor": counterColor }, rest), (0, exports.transformCounter)(count, maxCount)));
};
exports.Counter = Counter;
const AlertCounter = ({ count, counterBackgroundColor = exports.DEFAULT_COUNTER_BACKGROUND_COLOR, maxCount = DEFAULT_MAX_COUNT, size = DEFAULT_SIZE, counterColor }) => {
    return (react_1.default.createElement(styled_1.AlertCounterWrapper, null,
        count !== undefined && (react_1.default.createElement(exports.Counter, { counterColor: counterColor, counterBackgroundColor: counterBackgroundColor, count: count, size: size, maxCount: maxCount })),
        react_1.default.createElement(styled_1.StyledIcon, { name: "notification_outline", size: size })));
};
exports.AlertCounter = AlertCounter;
